import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import axios from "axios";
import FailPopUp from "./helpers/FailPopUp";

const Login = () => {

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const [submitLoader, setSubmitLoader] = useState(false)

    const [message, setMessage] = useState<string>('')
    const [failPopUp, setFailPopUp] = useState<boolean>(false)

    const [errors, setErrors] = useState<Record<string, string[]>>({})

    const navigate = useNavigate()
    const API_URL = `${process.env.REACT_APP_API_URL}`


    const login = async () =>
    {
        let payload = {username, password}

        setSubmitLoader(true)

        await axios.post(`${API_URL}/login`, payload, {withCredentials: true}, )
            .then(response => {
                if(response.status === 200)
                {
                    navigate('/dashboard')
                }
                setSubmitLoader(true)
            })
            .catch(error => {
                if(error)
                {
                    setSubmitLoader(false)
                    setMessage('Try again later!')
                    setFailPopUp(true)
                }
            })
    }

    return (
        <>
            {failPopUp && <FailPopUp message={message} setFailPopUp={setFailPopUp}/>}
            <div className="flex justify-center items-center h-screen bg-gray-100 px-4 sm:px-0">
                <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                    <h2 className="text-2xl font-semibold text-center text-gray-800 mb-2">Paulart</h2>
                        <div className="mb-4">
                            <label htmlFor="username" className="block text-gray-700 mb-2">Username</label>
                            <input
                                value={username}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                                type="text"
                                id="username"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                placeholder="Enter your Username"
                            />
                            <span className="error-text">{errors.username}</span>
                        </div>
                        <div className="mb-6">
                            <label htmlFor="password" className="block text-gray-700 mb-2">Password</label>
                            <input
                                value={password}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                type="password"
                                id="password"
                                className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                placeholder="Enter your password"
                            />
                            <span className="error-text">{errors.password}</span>
                        </div>
                        {submitLoader ? (
                            <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition-colors flex items-center justify-center">
                                <div
                                    className="w-6 h-6 border-4 border-t-blue-500 border-white rounded-full animate-spin"
                                ></div>
                            </button>
                        ) :(
                            <button className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-500 transition-colors" onClick={login}>Sign In</button>
                        )}
                </div>
            </div>
        </>
    );
};

export default Login;
